module.exports = __webpack_public_path__ + "static/media/Hotel-Schwarzenstein.db954f29.png";